import { useQuery } from "@tanstack/react-query";
import useApi from "@/contexts/ApiContext";
import { useAuth0 } from "@auth0/auth0-react";

const useOnrampProjects = (enabled = true) => {
  const api = useApi();
  const { user } = useAuth0();
  const userKey = user?.sub ?? user?.email;

  return useQuery({
    queryKey: ["get-onramp-projects", userKey],
    queryFn: () => api.onramp.getProjects(),
    enabled: enabled && Boolean(userKey),
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    throwOnError: false,
    retry: 0,
  });
};

export default useOnrampProjects;
